<template>
  <div class="navbar">
    <el-menu
      :default-active="activeMenu"
      mode="horizontal"
      class="navbar-menu"
      text-color="#fff"
      menu-trigger="hover"
      active-text-color="#fff">
      <template v-for="item in permission_routers">
        <template v-if="!item.hidden">
          <template v-if="hasOneShowingChild(item.children,item) && (!onlyOneChild.children||onlyOneChild.noShowingChildren)&&!item.alwaysShow">
            <menu-item-item :key="item.path" :item="item" :base-path="item.path" :only-one-child="onlyOneChild" />
          </template>
        </template>
      </template>
    </el-menu>
  </div>
</template>

<script>
import variables from '../../../../../src/styles/variables.scss'
import MenuItemItem from './MenuItemItem'
import SubMenu from './SubMenu'
import { mapState } from 'vuex'

export default {
  components: {
    MenuItemItem,
    SubMenu
  },
  data() {
    this.onlyOneChild = null
    return {
      activeIndex: '1',
      isNest: false,
      permission_routers: []
    }
  },
  computed: {
    variables() {
      return variables
    },
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    ...mapState({
      menuList: (state) => state['business/CommonService'].menuList
    })
  },
  created() {
    this.permission_routers = []
    const arr = this.$router.options.routes
    arr.forEach(e => {
      if (e.children) {
        this.permission_routers = this.permission_routers.concat(e.children)
      }
    })
    // 根据角色权限，加载对应的菜单
    // console.log(this.menuList)
    // 过滤第一层
    const a = this.permission_routers.filter(e => {
      return this.menuList.find(m => {
        return e.name === m.F_UrlAddress
      })
    })
    // 过滤子菜单
    a.forEach(e => {
      if (e.children) {
        e.children = e.children.filter(c => {
          return this.menuList.find(m => {
            return c.name === m.F_UrlAddress
          })
        })
      }
    })
    this.permission_routers = a
  },
  methods: {
    hasOneShowingChild(children = [], parent) {
      const showingChildren = children.filter(item => {
        if (item.hidden) {
          return false
        } else {
          this.onlyOneChild = item
          return true
        }
      })

      if (showingChildren.length === 1) {
        return true
      }

      if (showingChildren.length === 0) {
        this.onlyOneChild = { ... parent, path: '', noShowingChildren: true }
        return true
      }
      return false
    }
  }
}
</script>
<style lang="scss">
@import "~@/styles/variables.scss";
.navbar {
  height: calc(#{$headerHeight} + 1px);
  display: flex;
  flex-direction: row;
  width: 100%;
  .navbar-menu{
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    width: 100%;
  }
  .el-menu{
    background-color: transparent;
  }
  .el-menu.el-menu--horizontal{
    border-bottom: none;
  }
  .el-menu .el-menu--horizontal ul{
    border-bottom: none;
    background-color: #053765;
  }
  .el-menu-item{
    padding: 0;
    margin: 6px 0 !important;
    line-height: 40px !important;
    height: calc(100% - 12px) !important;
  }
  .el-menu-item,.el-submenu__title{
    font-size: 16px !important;
    letter-spacing: 0.12px;
  }
  .el-menu,.el-submenu,.el-menu--horizontal>.el-menu-item,.el-menu--horizontal>.el-submenu .el-submenu__title{
    height: 100%;
    line-height: $headerHeight;
  }
  .el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .el-menu .el-submenu__title{
    height: 36px;
    line-height: 36px;
    display: flex;
  }
  .el-menu--horizontal>.el-submenu .el-submenu__icon-arrow{
    line-height: $headerHeight;
  }
  .el-menu-item.is-active{
    border-bottom: solid 2px #a0eeff !important;
    background: -moz-linear-gradient(rgba(64,140,255,0.00) 0%,#408cff );
    background: -webkit-linear-gradient(rgba(64,140,255,0.00) 0%,#408cff );
  }
  .el-submenu__title i{
    color: #fff;
  }
  .el-menu--horizontal>.el-submenu.is-active .el-submenu__title{
    border-bottom: 0px !important;
  }
  .el-menu--horizontal>.el-menu-item:not(.is-disabled):focus, .el-menu--horizontal>.el-menu-item:not(.is-disabled):hover, .el-menu--horizontal>.el-submenu .el-submenu__title:hover {
    border-bottom: solid 2px #a0eeff !important;
    background: -moz-linear-gradient(rgba(64,140,255,0.00) 0%,#408cff );
    background: -webkit-linear-gradient(rgba(64,140,255,0.00) 0%,#408cff );
  }
  .el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .el-menu .el-submenu__title{
    background-color:#053765;
  }
  .el-menu--horizontal .el-menu-item:not(.is-disabled):focus, .el-menu--horizontal .el-menu-item:not(.is-disabled):hover{
    border-bottom: solid 2px #a0eeff !important;
    background: -moz-linear-gradient(rgba(64,140,255,0.00) 0%,#408cff );
    background: -webkit-linear-gradient(rgba(64,140,255,0.00) 0%,#408cff );
  }

}
</style>
<style lang="scss" scoped>
</style>
